export default "__VITE_ASSET__05X4c0qU__"